import {DatabaseCode, toDatabaseCode, toDatabaseCodeSafely} from "../database-code";

export type RrcWastePhysicalCharacteristic = DatabaseCode;

const solid: RrcWastePhysicalCharacteristic = {
  code: "SOLID",
  displayValue: {
    id: "common.entity.rrcwastephysicalcharacteristic.solid",
    defaultMessage: "Solid",
  },
};

const semiSolid: RrcWastePhysicalCharacteristic = {
  code: "SEMI_SOLID",
  displayValue: {
    id: "common.entity.rrcwastephysicalcharacteristic.semisolid",
    defaultMessage: "Semi-Solid",
  },
};

const liquid: RrcWastePhysicalCharacteristic = {
  code: "LIQUID",
  displayValue: {
    id: "common.entity.rrcwastephysicalcharacteristic.liquid",
    defaultMessage: "Liquid",
  },
};

export const rrcWastePhysicalCharacteristic = {
  solid,
  semiSolid,
  liquid,
};

export const rrcWastePhysicalCharacteristics: RrcWastePhysicalCharacteristic[] = Object.values(rrcWastePhysicalCharacteristic);

export const toRrcWastePhysicalCharacteristic = (code: string): RrcWastePhysicalCharacteristic =>
  toDatabaseCode(code, rrcWastePhysicalCharacteristics);

export const toRrcWastePhysicalCharacteristicSafely = (
  code: string | undefined,
  defaultValue: RrcWastePhysicalCharacteristic | undefined = undefined
): RrcWastePhysicalCharacteristic | undefined => toDatabaseCodeSafely(code, rrcWastePhysicalCharacteristics, defaultValue);
